import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import TruncateHtml from 'react-truncate-html';
import { withStyles, Button, Typography, RootRef, Grid } from '@material-ui/core';
import HTMLEntities from '../utils/HTMLEntities';

const styles = theme => ({
	button: {
		marginTop: -4
	},

	blockButton: {
		marginLeft: theme.spacing(-1),
		display: 'block'
	},

	toggleBtn: {
		marginTop: theme.spacing(.5)
	},

	originalContent: {
		whiteSpace: "pre-line"
	}
});

class ReadMore extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			expanded: false,
			truncated: false,
			truncationNeeded: null
		};

		this.handleTruncate = this.handleTruncate.bind(this);
		this.toggleLines = this.toggleLines.bind(this);

		this.truncateHtmlWrapper = React.createRef();
	}

	truncateContent(content, maxLines = 3) {
		const tempDiv = document.createElement("div");
		tempDiv.innerHTML = content;
		const textContent = tempDiv.innerHTML;

		const words = textContent.split(' ');
		const maxWords = maxLines * 14;

		return words.length <= maxWords
			? textContent
			: words.slice(0, maxWords).join(' ') + '...';
	}

	componentDidMount() {
		const { preserveHtml, html, originalContent, lines } = this.props;
		if (this.props.preserveHtml) {
			this.isHtmlTruncated();
		}

		const content = preserveHtml ? originalContent : html;

		if (content) {
			const tempDiv = document.createElement("div");
			tempDiv.innerHTML = content;
			const textContent = tempDiv.innerHTML;

			const words = textContent.split(' ');
			const maxWords = lines * 14;
			this.setState({ truncationNeeded: words.length > maxWords });
		} else {
			this.setState({ truncationNeeded: false });
		}
	}

	isHtmlTruncated() {
		if (this.truncateHtmlWrapper.current) {
			let current = this.truncateHtmlWrapper.current,
				child = current.firstChild;

			if (this.props.html !== child.innerHTML && child.innerText.match(/.*[.]{3}$/ig)) {
				this.setState({ truncationNeeded: true });
				this.handleTruncate(true);
			}
		} else {
			this.setState({ truncationNeeded: false });
		}
	}

	handleTruncate(truncated) {
		if (this.state.truncated !== truncated) {
			this.setState({ truncated });
		}
	}

	toggleLines(event) {
		event.preventDefault();
		event.stopPropagation();

		this.setState({
			expanded: !this.state.expanded
		});
	}

	render() {
		let { expanded, truncated, truncationNeeded } = this.state,
			{ classes, children, more, less, lines, showInline, ellipsis, preserveHtml, html, htmlEllipsis, originalContent, fromActivityContent = false } = this.props,
			btnClassNames = `${showInline ? classes.button : classes.blockButton} ${preserveHtml ? classes.toggleBtn : ""}`,
			moreButton = <Button
				size="small"
				color="primary"
				className={btnClassNames}
				onClick={this.toggleLines}>{more}</Button>,
			lessButton = <Button
				size="small"
				color="primary"
				className={btnClassNames}
				onClick={this.toggleLines}>{less}</Button>;
		const content = preserveHtml ? originalContent : html;
		const truncatedContent = this.truncateContent(content, lines);

		console.log(expanded, truncated, truncationNeeded)
		return (
			<div>
				{preserveHtml ?
					<RootRef rootRef={this.truncateHtmlWrapper}>
						{!expanded ?
							<div style={{ position: "relative" }}>
								<TruncateHtml
									ellipsis={htmlEllipsis}
									lines={lines}
									dangerouslySetInnerHTML={{ __html: html }} />
								{truncationNeeded ?
									showInline ?
										moreButton
										:
										<Grid container justify="flex-start">
											<Grid item>{htmlEllipsis}{moreButton}</Grid>
										</Grid>
									:
									originalContent ?
										showInline ?
											moreButton
											:
											<Grid container justify="flex-start">
												<Grid item>{htmlEllipsis}{moreButton}</Grid>
											</Grid>
										: null
								}
							</div>
							:
							truncationNeeded || originalContent ?
								<div style={{ position: "relative" }}>
									<Typography
										dangerouslySetInnerHTML={{ __html: originalContent || html }}></Typography>
									<Grid container justify="flex-start">
										<Grid item>{lessButton}</Grid>
									</Grid>
								</div> : null
						}
					</RootRef>
					:
					<>
						{!fromActivityContent && (<div>
							<Truncate
								lines={!expanded && lines}
								ellipsis={(
									<span>
										{ellipsis}
										{showInline ?
											moreButton
											:
											<Grid container justify="flex-start">
												<Grid item>{moreButton}</Grid>
											</Grid>
										}
									</span>
								)}
								onTruncate={this.handleTruncate}>
								{expanded ?
									originalContent ?
										<span className={classes.originalContent}><div dangerouslySetInnerHTML={{ __html: originalContent }} /></span>
										:
										children
									: <span>{children}{originalContent ? "..." : null}</span>  // not expanded
								}
							</Truncate>
							{!expanded && originalContent && !truncated ?
								showInline ?
									moreButton
									:
									<Grid container justify="flex-start">
										<Grid item>{moreButton}</Grid>
									</Grid>
								: null
							}
							{!truncated && expanded ?
								showInline ?
									lessButton
									:
									<Grid container justify="flex-start">
										<Grid item>{lessButton}</Grid>
									</Grid>
								: null}
						</div>)
						}
						{fromActivityContent && (
							<div>
								{!expanded ? (
									<span dangerouslySetInnerHTML={{ __html: truncatedContent }} />
								) : (
									children
								)}

								{!expanded && truncationNeeded ? (
									showInline ? (
										moreButton
									) : (
										<Grid container justify="flex-start">
											<Grid item>{moreButton}</Grid>
										</Grid>
									)
								) : null}

								{expanded && truncationNeeded ? (
									showInline ? (
										lessButton
									) : (
										<Grid container justify="flex-start">
											<Grid item>{lessButton}</Grid>
										</Grid>
									)
								) : null}
							</div>
						)}
					</>
				}
			</div>
		);
	}
}

ReadMore.defaultProps = {
	lines: 3,
	more: 'Read More',
	less: 'Show Less',
	ellipsis: '...',
	htmlEllipsis: "..."
};

ReadMore.propTypes = {
	classes: PropTypes.object.isRequired,
	children: PropTypes.node,
	lines: PropTypes.number,
	less: PropTypes.string,
	more: PropTypes.string,
	showInline: PropTypes.bool,
	ellipsis: PropTypes.string,
	htmlEllipsis: PropTypes.string,
	preserveHtml: PropTypes.bool,
	html: PropTypes.string,
	originalContent: PropTypes.string
};

export default withStyles(styles)(ReadMore);
